export default __webpack_public_path__ + "static/media/coffee.41a6a3d6.png";